import { readStorage } from "../readStorage";

// const cacheVersion = process.env.REACT_APP_CACHE_VERSION;

export function writeAutosaveStorage(key, value) {
    const currentObj = readStorage('autosave_transactions') || {};

    localStorage.setItem('autosave_transactions', JSON.stringify({...currentObj, [key]: value}));
    // localStorage.setItem('cache_version', cacheVersion);
}
